/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import * as s from './css/hero-image.module.css';
import Button from "../../../../components/button";
import { urls } from "../../../../constants";


const HeroImage = ({ project }) => {

  const dataImages = useStaticQuery(graphql`
{
  allFile {
    edges {
      node {
        publicURL
        base
      }
    }
  }
}
`)

  const heroImage = dataImages.allFile.edges.find(e => e.node.base.indexOf(`hero_${project.__influencerCode}.`) === 0);

  return (
    <div className={`full-container flex justify-center ${s.container}`}>
      <div className="flex flex-col items-center desktop:flex-row" style={{paddingTop:'30px'}}>
        <div className={`${s.influencerImageContainer}`}>
          <img src={heroImage.node.publicURL} alt="immagine principale" />
        </div>
        <div className={`${s.influencerTextContainer}`}>
          <div className="flex flex-col" style={{ backgroundColor:project.__heroImage.backgroundColor }}>
            <div className={s.heroText} style={{ textShadow:`3.5px 0px 0px ${project.__heroImage.color}`, WebkitTextStrokeColor:project.__heroImage.color }} dangerouslySetInnerHTML={{__html: project.__heroImage.text }} />
            <div className={s.containerBtnOutline}>
              <Button 
              style={{ border:`1px solid ${project.__heroImage.buttonColor}`, color:project.__heroImage.buttonColor }}
              className={`${s.btnOutline}`} onClick={() => {
                                  window.location.href = urls.ATTIVA_TINABA_HIT;
                              }}>
                  Attiva Tinaba Hit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroImage
